
import UserApprovalTabs from '@/components/UserApprovalTabs';

const UserApprovals = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-center mb-8">User Approvals</h1>
        <UserApprovalTabs />
      </div>
    </div>
  );
};

export default UserApprovals;